import { ComponentElem } from "@components/interfaces";
import PopupBase from "./PopupBase";
import Popups from "./Popups";
import GS from "@root/ts/GlobalSetting";
import EZAlert from "./EZAlert";
import FormTools from "@root/ts/FormTools";
import login_by_email from "@schema/common/login-by-email.json";
import Captcha from "../ui/inputs/Captcha";
import LoginRegister from "./LoginRegister";
import Utility from "../../ts/sframe/Utility";

export default class LoginByEmail extends PopupBase
{
  static instance: LoginByEmail;

  $btnLogin: JQuery;

  private _captcha: Captcha;

  constructor(elem: ComponentElem)
  {
    super(elem);

    LoginByEmail.instance = this;

    this._captcha = this.seekComponentByName("captcha");
    this._captcha.emitter.on("token-change", (token: string) =>
    {
      token ?
        this.$btnLogin.removeAttr("disabled") :
        this.$btnLogin.attr("disabled", "true");
    });

    this.$btnLogin = this.$root.find(".btn-login").on("click", (event: JQuery.ClickEvent) =>
    {
      event.preventDefault();

      const params = Utility.getCurrentUrlParams();
      let result = this.getFormData();

      if (result.isReady) {
        const params = Utility.getCurrentUrlParams();
        if (params["redirect-url"] !== undefined) {
          const formDataWithRedirectUrl = { ...result.formData, 'redirect-url': params["redirect-url"] };
      
          FormTools.sendForm("common/login-by-email", formDataWithRedirectUrl, this.$root, { schema: login_by_email, autoCloseAlert: false })
            .then((result) => {
              FormTools.handleNextUrl(result);
            })
            .catch(() => {
              this.toMe();
            });
        } else {
          FormTools.sendForm("common/login-by-email", result.formData, this.$root, { schema: login_by_email, autoCloseAlert: false })
            .then((result) => {
              FormTools.handleNextUrl(result);
            })
            .catch(() => {
              this.toMe();
            });
        }
      }
    });

    this.$root.find(".to-regist").on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      LoginRegister.instance.toMe();
    });
  }

  getFormData()
  {
    let result = FormTools.getFormData(this.$root);
    result.formData.captcha_token = this._captcha.token;

    if (!this._captcha.token) {
      result.isReady = false;
      EZAlert.alert("請先完成驗證").then(()=>
      {
        this.toMe();
      })
    }

    return result;
  }

  toMe()
  {
    this._captcha.ready().then(()=>
    {
      this.reset();
      Popups.to("login-by-email");
    });
  }

  reset()
  {
    this.$btnLogin.attr("disabled", "true");
    this._captcha.reset();
  }
}